import {auth, db, storage} from './firebase/index'
import * as moment from 'moment'

/**
 * When user select an image file from his local directory, upload it to Firebase Storage, get download URL,
 * and set the URL to the src property of img tag for displaying the thumbnail.
 */
export const attachFiles = (id, event) => {
    const file = event.target.files;
    const file_name = file[0].name;
    const blob = new Blob(file, { type: "image/jpeg" });

    const uploadRef = storage.ref('image').child(file_name);
    const uploadTask = uploadRef.put(blob);
    uploadTask.on('state_changed', (snapshot) => {
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log('Upload is ' + progress + '% done');
    }, (error) => {
        // Handle unsuccessful uploads
        console.error("Failed to upload file. ERROR: ", error);
    }, () => {
        // Handle successful uploads on complete
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            console.log('File available at', downloadURL);
            document.getElementById(`${id}-thumb`).setAttribute('src', downloadURL);
            document.getElementById(id).setAttribute('data-name', file_name);
            this.setState({
                [id]: downloadURL
            })
        });
    });
};

/**
 * Calculate how long ago a comment is posted from now.
 * @param {int} updatedTime The datetime as Number like YYYYMMDDHHmmss
 * @returns {string}
 */
export const calcHowLongAgo = (updatedTime) => {
    const date = formatReadableDatetime(updatedTime);
    return moment(date, 'YYYY/MM/DD HH:mm:S').fromNow();
};

/**
 * Calculate what age is user's birthday (YYYY年MM月DD日)
 * @param {string} birthday
 * @return {int} age
 */
export const calcWhatAge = (birthday) => {
    let formattedBirthday = birthday.split('年')[0]
        + ("00" + birthday.split('年')[1].split('月')[0]).slice(-2)
        + ("00" + birthday.split('月')[1].split('日')[0]).slice(-2);

    return moment().diff(formattedBirthday, 'years')
};


/**
 * Remove hyphen, space, slash, and colon from the String.
 * @param datetimeString like as "YYYY/MM/DD HH:mm:ss", "YYYY-MM-DD HH:mm:ss" , or so.
 * @returns {number} formattedDatetime as YYYYMMDDHHmmss
 */
export const convertDatetimeStringIntoNumber = (datetimeString) => {
    // Create pattern to match with hyphen, space, slash, and colon.
    const pattern = /[\-:\s\/]/g

    // Delete strings match this pattern
    const formattedDatetime = datetimeString.replace(pattern, "");

    return Number(formattedDatetime)
}

/**
 * Convert Carriage Return and Line Feed into <br> tag.
 * @param {string} text The row text
 * @returns {void | string | never} The formatted text
 */
export const convertCrlfToBr = (text) => {
    return text.replace(/\r?\n/g, '<br>');
};

/**
 * Convert datetime as Number into the one as String.
 * @param {int} datetimeNumber as YYYYMMDDHHmmss
 * @returns {string} "YYYY/MM/DD HH:mm:ss"
 */
export const formatReadableDatetime = (datetimeNumber) => {
    const datetimeString = String(datetimeNumber);
    return datetimeString.slice(0,4) + "/"
        + datetimeString.slice(4,6) + "/"
        + datetimeString.slice(6,8) + " "
        + datetimeString.slice(8,10) + ":"
        + datetimeString.slice(10,12) + ":"
        + datetimeString.slice(12,14);
};


/**
 * Convert datetime as Number into the one as String for fitting the format of Flatpckr.
 * @param datetimeNumber as YYYYMMDDHHmmss
 * @returns {string} "YYYY-MM-DD HH:mm:ss"
 */
export const formatFlatpckrDatetime = (datetimeNumber) => {
    const datetimeString = String(datetimeNumber);
    return datetimeString.slice(0,4) + "-"
        + datetimeString.slice(4,6) + "-"
        + datetimeString.slice(6,8) + " "
        + datetimeString.slice(8,10) + ":"
        + datetimeString.slice(10,12) + ":"
        + datetimeString.slice(12,14);
};

/**
 * Get the current datetime and format as Number.
 * @returns {number} datetime The datetime as Number like YYYYMMDDHHmmss
 */
export const getDatetimeAsNumber = () => {
    const now = new Date();
    const year = now.getFullYear().toString();
    const month = ("00" + (now.getMonth()+1)).slice(-2);
    const day = ("00" + now.getDate()).slice(-2);
    const hour = ("00" + now.getHours()).slice(-2);
    const minute = ("00" + now.getMinutes()).slice(-2);
    const second = ("00" + now.getSeconds()).slice(-2);
    const datetime = (year + month + day + hour + minute + second);

    return Number(datetime)
};

/**
 * Verify the argument is NULL or not.
 * @param {*} checkedValue
 * @returns {*} When it is NULL, return "" as String
 */
export const isNull = (checkedValue) => {
    if (checkedValue) {
        return checkedValue
    }else{
        return ""
    }
};


/**
 * Count the number of inputted letters
 * @param id The identifier of <input> or <textarea> which you want to count the number of letters.
 * @returns {string}
 */
export const lengthCount = (id) => {
    const currentLength = document.getElementById(id).value.length;
    const maxLength = document.getElementById(id).maxLength;
    return document.getElementById(`${id}-length-count`).innerText = `(${currentLength}/${maxLength})`;
};


export const setPagination = (maxPage, currentPage) => {
    // Get a DOM node for pagination
    const paginationHtml = document.getElementById("pagination");

    // Set variable for pagination
    let pagination = "";
    const pageNum = 5;  // The number of pages to display as selected page
    const pageEnd = pageNum - 1;  //
    const pagePos = 2;  // Position of active page (pageNum - 1 - pagePos)
    const previousPage = currentPage - 1;  // Previous page number
    const nextPage = currentPage + 1;  // Next page number
    let startPage = 0;  // Start page number
    let endPage = 0;  // End page number
    // Determine start page
    if (maxPage <= pageNum) {
        startPage = 1;
    } else {
        if (currentPage - pagePos > 1) {
            startPage = currentPage - pagePos;
        } else {
            startPage = 1;
        }
        if (startPage + pageEnd > maxPage) {
            startPage = maxPage - pageEnd;
        }
    }
    if (maxPage <= pageNum) {
        endPage = maxPage;
    } else {
        endPage = startPage + pageEnd
    }
    // Set top page button
    pagination += `<nav aria-label="Page navigation example">
                        <ul class="pagination justify-content-center">
                          <li class="page-item">
                            <a class="page-link" href="?page=1" aria-label="Top">
                              <span aria-hidden="true">&laquo;</span><span class="sr-only">Top</span>
                            </a>
                          </li>`;
    // Set prev page button
    if (currentPage > 1) {
        pagination += `<li class="page-item">
                            <a class="page-link" href="?page=${previousPage}" aria-label="Previous">
                              <span aria-hidden="true">&lt;</span><span class="sr-only">Previous</span>
                            </a>
                           </li>`;
    }
    // Determine which button is current page
    for (startPage; startPage <= endPage; startPage++) {
        if (startPage === currentPage) {
            pagination += `<li class="page-item active">
                                <a class="page-link" href="?page=${startPage}">
                                  ${startPage}<span class="sr-only">(current)</span>
                                </a>
                               </li>`;
        }else{
            pagination += `<li class="page-item">
                                <a class="page-link" href="?page=${startPage}">${startPage}</a>
                               </li>`;
        }
    }
    // Set next page button
    if (maxPage > currentPage) {
        pagination += `<li class="page-item">
                            <a class="page-link" href="?page=${nextPage}" aria-label="Next">
                              <span aria-hidden="true">&gt;</span><span class="sr-only">Next</span>
                            </a>
                           </li>`;
    }
    // Set last page button
    pagination += `<li class="page-item">
                        <a class="page-link" href="?page=${maxPage}" aria-label="Last">
                          <span aria-hidden="true">&raquo;</span><span class="sr-only">Last</span>
                        </a>
                       </li>
                      </ul>
                     </nav>`;
    // Load pagination view
    paginationHtml.innerHTML = pagination;
    return true
};

export const signOut = () => {
    return auth.signOut().then(() => {
        return window.location.href = '/'
    }).catch((error) => {
        console.log(error);
    });
};

export const switchSelectedButton = (name) => {
    const nameValues = document.getElementsByName(name);
    nameValues.forEach((nameValue) => {
        if (nameValue.checked) {
            nameValue.className = "p-button-selected";
        } else {
            nameValue.className = "p-button-unselected";
        }
    })
};

export const updateMultiPath = (updateJson) => {
    return db.ref().update(updateJson)
};

export const $ = (id) => {
    return document.getElementById(id)
};

